// --- components/horseDetails/HorseHealth.jsx ---
import React from 'react';

export default function HorseHealth({ health }) {
  if (!health) return null;

  const {
    status,
    vetCheckDate,
    vetCheckNA,
    vetCheckExplanation,
    knownIssues
  } = health;

  return (
    <div className="mt-5 p-3 font-montserrat shadow">
      <h2 className="text-xl font-bold mb-2">Health Records</h2>
      <div className="flex flex-col">
        <p className="py-2"><strong>Status:</strong> {status || 'N/A'}</p>
        <p className="py-2">
          <strong>Last Vet Check:</strong>{' '}
          {vetCheckNA
            ? 'Not Applicable'
            : vetCheckDate
            ? new Date(vetCheckDate).toLocaleDateString()
            : 'N/A'}
        </p>
        {vetCheckNA && vetCheckExplanation && (
          <p className="py-2"><strong>Explanation:</strong> {vetCheckExplanation}</p>
        )}
        <p className="py-2"><strong>Known Issues / Injuries:</strong> {knownIssues || 'None reported'}</p>
      </div>
    </div>
  );
}